import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 4
const slug = 'posi-track-excavator-hire-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Posi Track Excavator Hire Sydney | ${BUSINESS_NAME}`,
        description: "Multi-terrain loader hire for steep, wet, and difficult-access commercial sites, protecting surfaces while delivering top performance.",
        keywords: "posi track excavator hire sydney, multi-terrain loader hire, skid steer loader hire, compact track loader hire, construction equipment rental, earthmoving equipment, site preparation, landscaping equipment, commercial site work, residential site work, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Posi Track Excavator Hire Sydney',
    description: "Multi-terrain loader hire for steep, wet, and difficult-access commercial sites, protecting surfaces while delivering top performance.",
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
